import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["mainImage"];

  onThumbnailClick(e) {
    e.preventDefault();
    this.mainImageTarget.src = e.currentTarget.querySelector("img").src;
    this.element.querySelectorAll("a.active").forEach(e => e.classList.remove("active"));
    e.currentTarget.classList.add("active");
  }  
}
